import { Link } from 'react-router-dom';

const columns = [
  {
    title: '内容导航',
    links: [
      { label: '首页', path: '/' },
      { label: '新闻中心', path: '/news' },
      { label: '影视作品', path: '/works' },
      { label: '明星资料', path: '/profile' },
    ],
  },
  {
    title: '关于本站',
    links: [
      { label: '关于我们', path: '/about' },
      { label: '全站搜索', path: '/search' },
      { label: '联系我们', path: '/about' },
      { label: '版权声明', path: '/about' },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="mt-20 bg-primary-950 text-background-100">
      <div className="px-4 py-12 md:px-8 md:py-16">
        <div className="mx-auto grid max-w-6xl grid-cols-1 gap-10 md:grid-cols-4">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className="ri-movie-2-line text-lg"></i>
              </span>
              <span className="font-heading text-lg font-bold tracking-wide text-background-50">
                深田咏美
              </span>
            </div>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-background-300">
              汇聚深田咏美的最新作品、新闻动态与明星资料，为影迷与资讯关注者提供专业、及时的娱乐资讯服务。
            </p>
            <div className="mt-5 flex items-center gap-3">
              {[
                { icon: 'ri-weibo-fill', label: '微博' },
                { icon: 'ri-wechat-fill', label: '微信' },
                { icon: 'ri-youtube-fill', label: '视频' },
                { icon: 'ri-instagram-line', label: '图文' },
              ].map((s) => (
                <span
                  key={s.label}
                  title={`${s.label}（演示链接）`}
                  className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-900 text-background-300 transition-colors hover:bg-primary-700 hover:text-background-50 cursor-pointer"
                >
                  <i className={`${s.icon} text-base`}></i>
                </span>
              ))}
            </div>
          </div>

          {columns.map((col) => (
            <div key={col.title}>
              <h4 className="font-heading text-sm font-semibold text-background-50">
                <a href="#footer">{col.title}</a>
              </h4>
              <ul className="mt-4 space-y-3">
                {col.links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.path}
                      className="text-sm text-background-300 transition-colors hover:text-primary-300 cursor-pointer"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>

      <div className="border-t border-primary-900">
        <div className="flex flex-col items-center justify-between gap-3 px-4 py-5 text-xs text-background-400 md:flex-row md:px-8">
          <p>© 2026 深田咏美明星资讯网 · 本站为粉丝资讯演示站点</p>
          <p>内容为演示数据，仅供参考 · Content is for demonstration only</p>
        </div>
      </div>
    </footer>
  );
}